import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import { getLedgerStatementData } from "_services/accountsServices/ledgerStatementServices";
import {
  ButtonHeading,
  CommonDateRange,
  CommonInput,
  NavTabs,
} from "components";
import { UserContext } from "context";
import { utils } from "helper";
import { Link, useNavigate, useParams } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import LoadingBar from "react-top-loading-bar";
import moment from "moment";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { ConfirmModalFor, PaymentVoucher } from "modals";
import { deleteTransactionApi } from "_services";
import toast from "react-hot-toast";
import { Images } from "constants";
import useDocumentTitle from "hooks/useDocumentTitle";
import { API, AppConfig } from "lib";
import './ledger.css'
import { getSupplierDetailsData } from "_services/accountsServices/supplierServices";
import { useLocation } from "react-router-dom";
import printHtmlContent from "helper/utils";
import { getVoucherReport } from "_services/accountingServices/accountingServices";

const nameObject = {
  1: 'Supplier',
  2: 'Party',
  3: 'Driver',
  4: 'Vendor',
  5: 'Fuel Station',
  8: 'Staff',
}

const LedgerNewDesign = (props) => {
  let { setLedgerDetails, supplierDataFunc, setDetailsData } = props;
  let companyID = StorageService.getCompanyId();
  let userDetailsData = JSON.parse(StorageService.getLocalItem("userData"));
  let compName = userDetailsData?.user_detail?.company_list.find((el) => (el?.company_id?._id === companyID) ? el : '')

  let isToken = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const vendorType = pathname.split("/")[2];
  useDocumentTitle("Ledger | T360");
  let runing_balance = 0;
  let { id } = useParams();
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);
  const containerRef = useRef(null);
  let { type } = props;

  // Use refs to track state that needs to be checked synchronously
  const hasMoreDataRef = useRef(true);
  const isLoadingRef = useRef(false);
  const currentOffsetRef = useRef(1);

  const currentDate = new Date();
  const firstDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    1
  );
  const lastDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const { masterData, cities, states } = useContext(UserContext);
  const [ledgerStatementData, setLedgerStatementData] = useState([]);
  const [accountDetails, setAccountDetails] = useState({});
  const [openingBalance, setOpeningBalance] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [crdDbtAmount, setCrdDbtAmount] = useState({});
  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [totalItems, setTotalItems] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [printLoadingId, setPrintLoadingId] = useState(null);


  const getDataLedgerStatement = async (idd, offset, isLoadMore = false) => {
    // Guard: Check refs synchronously
    if (isLoadingRef.current) {
      return;
    }

    if (isLoadMore && !hasMoreDataRef.current) {
      return;
    }

    try {
      isLoadingRef.current = true;

      if (!isLoadMore && loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }

      if (isLoadMore) {
        setIsLoadingMore(true);
      }

      let object = {
        limit: 100,
        offset: offset,
        start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
        company_id: StorageService.getCompanyId(),
        vendor_type: type,
        vendor_id: idd,
      };

      const res = await getLedgerStatementData(object);

      if (res?.responseCode == 200) {
        setLedgerDetails(res?.data?.account_detail);
        setAccountDetails(res?.data?.account_detail);
        setCrdDbtAmount({ total_credit_amount: res?.data?.total_credit_amount, total_debit_amount: res?.data?.total_debit_amount });

        let newData = res?.data?.list || [];
        let totalRecord = res?.data?.total_record || 0;

        if (isLoadMore) {
          // Skip first item (duplicate default entry)
          const dataToAppend = newData.slice(1);

          setLedgerStatementData((prev) => {
            const updatedData = [...prev, ...dataToAppend];
            const actualCount = updatedData.length - 1;

            // Update ref immediately
            hasMoreDataRef.current = actualCount < totalRecord;

            return updatedData;
          });
        } else {
          setLedgerStatementData(newData);
          const actualCount = Math.max(0, newData.length - 1);

          // Update ref immediately
          hasMoreDataRef.current = actualCount < totalRecord;
        }

        setOpeningBalance(res?.data?.opening_balance);
        setAvailableBalance(res?.data?.available_balance);
        setTotalItems(totalRecord);
      }
    } catch (error) {
    } finally {
      if (!isLoadMore && loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
      if (isLoadMore) {
        setIsLoadingMore(false);
      }

      isLoadingRef.current = false;
    }
  };

  // NEW: Direct load more function - no state changes, direct API call
  const loadMoreData = useCallback(() => {
    // Check refs synchronously
    if (isLoadingRef.current || !hasMoreDataRef.current) {
      return;
    }

    const nextOffset = currentOffsetRef.current + 1;
    currentOffsetRef.current = nextOffset;

    getDataLedgerStatement(id, nextOffset, true);
  }, [id, selectedRange, type]);

  // Simplified scroll handler - calls loadMoreData directly
  const handleScroll = useCallback((e) => {
    const el = e.target;
    if (!el) return;

    const scrollThreshold = 100;
    const isNearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - scrollThreshold;

    if (isNearBottom) {
      loadMoreData();
    }
  }, [loadMoreData]);

  const getDataSupplierDetails = async (id_1) => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }
      let object = {
        supplier_id: id_1,
      }
      const res = await getSupplierDetailsData(object);
      if (res?.responseCode == 200) {
        supplierDataFunc(res?.data?.supplier);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  }

  // Reset and load initial data
  useEffect(() => {
    // Reset refs
    hasMoreDataRef.current = true;
    isLoadingRef.current = false;
    currentOffsetRef.current = 1;

    // Reset state
    setLedgerStatementData([]);
    setIsLoadingMore(false);

    // Load initial data
    getDataLedgerStatement(id, 1, false);
  }, [id, selectedRange, props.refresh]);

  useEffect(() => {
    if (id && vendorType === "supplier") {
      setLoading(true);
      getDataSupplierDetails(id);
    }
  }, [id])

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
  };

  const handleDelteSubmit = (i) => {
    setConfirmModalShow(i);
  };

  const handleDelete = async () => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: confirmModalShow?.transaction_id || paymentVoucherOpen?.transaction_id,
    };
    try {
      setDeleteLoading(true);
      const res = await deleteTransactionApi(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setConfirmModalShow(false);
        setDeleteLoading(false);

        // Reset everything
        hasMoreDataRef.current = true;
        isLoadingRef.current = false;
        currentOffsetRef.current = 1;
        setLedgerStatementData([]);

        getDataLedgerStatement(id, 1, false);
        setPaymentVoucherOpen(false);
      } else {
        setDeleteLoading(false);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      setDeleteLoading(false);
      toast.error(error?.message);
    }
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => {
      setConfirmModalShow(false);
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading,
  };

  const getCategoriesNames = (item) => {
    if (item?.category_type == 1) {
      return <>{item?.categories[0]?.category?.name}</>;
    }
    if (item?.category_type == 2) {
      return <>{item?.category_name}</>;
    }
  };

  const getDownloadLedgerReport = async () => {
    setLoading(true)
    try {
      const payload = {
        start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        company_id: StorageService.getCompanyId(),
        vendor_type: type,
        vendor_id: id,
        is_web: true,
      }
      const response = await fetch(`${AppConfig.api_baseurl}${API.LEDGER_REPORT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': `${isToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${nameObject[type]}-ledger-statement.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const exportHandle = async () => {
    setExcelLoading(true);
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        vendor_id: id,
      };
      const response = await fetch(
        `${AppConfig.api_baseurl}${API.EXPORT_FUEL_STATION_TRANSACTION}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Token: `${isToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "transport360_FuelStation.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setExcelLoading(false);
    } catch (error) {
      setExcelLoading(false);
    }
  };


  const handlePrintDownload = async (voucherId) => {
    try {
      setPrintLoadingId(voucherId);

      const res = await getVoucherReport({
        company_id: StorageService?.getCompanyId(),
        voucher_id: voucherId,
      });

      printHtmlContent({
        html: res,
        title: `Bilty-${voucherId}`,
        onAfter: () => setPrintLoadingId(false),
      });

    } catch (err) {
      console.error('Print error:', err);
      setPrintLoadingId(false);
    }
  };

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?._id,
    oprnDeleteModal: setConfirmModalShow,
    onPrintHandle: handlePrintDownload,
    printLoadingId
  };

  return (
    <>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />

      <div className="_rangeDate_bx_ledger">
        <div className="_fleX_inds_ledger">
          <div className="" style={{ maxWidth: '210px', width: '100%' }}>
            <CommonDateRange
              initialStartDate={selectedRange.startDate}
              initialEndDate={selectedRange.endDate}
              onApply={handleApply}
            />
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            {type == 5 && <button className='_addComm_btn' onClick={(e) => exportHandle(e)} disabled={excelLoading}> {excelLoading ? "Loading..." : 'Export'} </button>}
            <button className='_addComm_btn' onClick={(e) => getDownloadLedgerReport(e)} disabled={loading}> {loading ? "Loading..." : 'Download'} </button>
          </div>
        </div>
      </div>

      <div
        className='__otrLdg_page pre-scrollable'
        ref={containerRef}
        onScroll={handleScroll}
        style={{
          maxHeight: '600px',
          overflowY: 'auto',
          overflowX: 'auto'
        }}
      >
        <div className="page-wrapper">

          <section className="header-section">
            <div className="title-block">
              <h1>Statement of Accounts</h1>
              <div className="badge-row">
                <span className="badge badge-white">Statement #ST-{utils.formateDateCalander(new Date())}-01</span>
                <span className="__text_muted">Period:{" "}
                  {moment(selectedRange.startDate).format("DD MMM YYYY")} To {moment(selectedRange.endDate).format("DD MMM YYYY")}
                </span>
              </div>
            </div>
            <div className="generated-block">
              <span className="__text_muted">Generated on</span>
              <div className="generated-date">{moment(new Date()).format('DD MMM YYYY')}</div>
            </div>
          </section>

          <section className="__cardLdg __account-info">
            <div className="grid three-cols">
              <div>
                <h3>Account Holder</h3>
                <p className="bold __margP_btm">{compName?.company_id?.company ? compName?.company_id?.company : ''}{" "}</p>
                <p className="__text_muted">{accountDetails?.address_line1 &&
                  accountDetails?.address_line1}{" "}
                  {accountDetails?.city?.value && accountDetails?.city?.value}{" "}
                  {accountDetails?.state?.label && accountDetails?.state?.label}
                </p>
              </div>
              <div>
                <h3>Statement Period</h3>
                <p className="bold __margP_btm">{moment(selectedRange.startDate).format("DD MMM YYYY")} To {moment(selectedRange.endDate).format("DD MMM YYYY")}</p>
                <p className="__text_muted">Monthly Statement</p>
              </div>
              <div>
                <h3>Contact Information</h3>
                <p className="__text_muted __margP_btm"> Phone: {accountDetails?.contact_no ? `+91 ${accountDetails?.contact_no}` : (accountDetails?.alt_contact_no ? `+91 ${accountDetails?.alt_contact_no}` : 'Not Available')}</p>
                <p className="__text_muted"> Email: {accountDetails?.email ? accountDetails?.email : 'Not Available'}</p>
              </div>
            </div>
          </section>

          <section className="__cardLdg __account-summary">
            <h4>Account Summary</h4>
            <div className="grid four-cols">
              <div className="summary-box">
                <div className="label">Opening Balance</div>
                <div className="value">{openingBalance ? `₹ ${openingBalance?.toFixed(2)}` : `₹ 0.00`}</div>
              </div>
              <div className="summary-box">
                <div className="label">Total Debits</div>
                <div className="value">
                  {crdDbtAmount?.total_debit_amount > 0 ? ` ₹ ${crdDbtAmount?.total_debit_amount?.toFixed(2)}` : `₹ 0.00`}
                </div>
              </div>
              <div className="summary-box">
                <div className="label">Total Credits</div>
                <div className="value green">
                  {crdDbtAmount?.total_credit_amount > 0 ? ` ₹ ${crdDbtAmount?.total_credit_amount?.toFixed(2)}` : `₹ 0.00`}
                </div>
              </div>
              <div className="summary-box">
                <div className="label">Closing Balance</div>
                <div className="value "> {availableBalance ? ` ₹ ${(availableBalance)?.toFixed(2)}` : `₹ 0.00`} </div>
              </div>
            </div>
          </section>

          <section className="__cardLdg __account_tableInfo">
            <div className="table-header">
              <h4>Transaction Details</h4>
            </div>
            <div className="table-container pre-scrollable">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Voucher No.</th>
                    <th>Transaction Type</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th> Vehicle No. </th>
                    <th className="right">Debit Amount</th>
                    <th className="right">Credit Amount</th>
                    <th className="right">Running Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {ledgerStatementData?.length > 0 ? (
                    ledgerStatementData?.map((el, ind) => {
                      runing_balance += el?.vendor_detail?.debit_amount - el?.vendor_detail?.credit_amount;

                      return (
                        <tr key={ind}>
                          <td className="__mediumFont">{utils.getDateByApiResponse(el?.date)}</td>
                          <td onClick={() =>
                            el?.voucher_no && setPaymentVoucherOpen(el)
                          }> <code className="__codeBg" style={{ cursor: "pointer" }}>{el?.sequence_no ? el?.sequence_no : (el?.voucher_no ? el?.voucher_no : "-")}{" "}</code></td>
                          <td>
                            <span
                              className={
                                (el?.sub_type_name === "Total Freight" || el?.type_name === "Total Freight")
                                  ? "badge blueBadge"
                                  : (el?.sub_type_name === "Charge Party" || el?.type_name === "Charge Party")
                                    ? "badge orangeBadge"
                                    : (el?.sub_type_name === "Invoice Payment" || el?.type_name === "Invoice Payment")
                                      ? "badge greenBadge"
                                      : "badge light"
                              }
                            >
                              {el?.sub_type_name || el?.type_name}
                            </span>
                          </td>
                          <td className="__text_muted">{getCategoriesNames(el)}</td>
                          <td>
                            <div className="dFsx2">
                              <div className="fBold">
                                <Link
                                  className=""
                                  onClick={(e) =>
                                    navigate(
                                      `/trip/addtrip/dispatched/${el?.trip?._id}`
                                    )
                                  }
                                >
                                  {el?.trip?.trip_number
                                    ? `${el?.trip?.trip_number}`
                                    : ""}{" "}
                                </Link>
                                {el?.trip?.route_name
                                  ? `- ${el?.trip?.route_name}`
                                  : ""}{" "}
                                {el?.trip?.route_name && el?.description
                                  ? " | "
                                  : ""}
                                {el?.description
                                  ? `${el?.description}`
                                  : ""}
                              </div>
                            </div>
                          </td>
                          <td className="__mediumFont"> {el?.tags?.vehicle?.vehicle_no ? el?.tags?.vehicle?.vehicle_no : '-'} </td>
                          <td className="right __redFont __mediumFont"> <span style={{whiteSpace:'nowrap'}}>{el?.vendor_detail?.debit_amount ? `₹ ${(el?.vendor_detail?.debit_amount).toFixed(2)} ` : "-"}</span></td>
                          <td className="right __mediumFont" style={{ color: "green" }}> <span style={{whiteSpace:'nowrap'}}>{el?.vendor_detail?.credit_amount ? `₹ ${(el?.vendor_detail?.credit_amount).toFixed(2)} ` : "-"}</span></td>
                          <td className="right __mediumFont"><span style={{whiteSpace:'nowrap'}}>{runing_balance ? ` ₹ ${(runing_balance).toFixed(2)}` : `₹ 0`}</span></td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9" className="p-2 text-center"> No data </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {isLoadingMore && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <div>Loading more...</div>
                </div>
              )}

              {!hasMoreDataRef.current && ledgerStatementData?.length > 0 && (
                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                  No more transactions to load
                </div>
              )}
            </div>

            <div className="table-footer">
              <span>Showing {Math.max(0, ledgerStatementData?.length - 1)} of {totalItems} transactions</span>
            </div>
          </section>

        </div>
      </div>

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx"> Are you sure you want to delete ?</p>
          </>
        </ConfirmModalFor>
      )}

      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
    </>
  );
};

export default LedgerNewDesign;